<template>
  <div class="nation">
    <img :src="content.nationPath" alt="" class="nation_icon" @click="itemClick">
    <div>{{content.name}}</div>
  </div>
</template>

<script>
  export default {
    name: "national",
    props: {
      content:{
        type: Object,
        default: function () {
          return{
            id: 0,
            name: '美国站',
            nationPath: '../../img/美国站.png',
            path: 'https://www.baidu.com'
          }
        }
      },
      isSelect: {
        type: Boolean,
        default: false,
      }
    },
    methods: {
      itemClick(){
        window.open(this.content.path)
      }
    }
  }
</script>

<style scoped>
  .nation{
    text-align: center;
  }

  .nation:hover{
    background-color: #fffacf;
    cursor: pointer;
  }

  .nation_icon{
    text-align: center;
  }

  @media screen and (max-width: 1600px) {
    .nation{
      padding: 0.4rem 3rem;
    }

    .nation_icon{
      width: 6rem;
    }
  }

  @media screen and (min-width: 1600px){
    .nation{
      padding: 5px 30px;
      font-size: 14px;
    }

    .nation_icon{
      width: 100px;
    }
  }
</style>
